import { Component, OnInit } from '@angular/core';
import { MercadoriasService } from "./mercadorias.service";
import { MercadoriasModel } from "./mercadorias.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from "../login/login.service";
import { FormBuilder, FormGroup } from "@angular/forms";

declare var swal, $: any;

@Component({
  selector: 'app-mercadorias',
  templateUrl: './mercadorias.component.html'
})
export class MercadoriasComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "nome": "", "ncm": "" };

  mercadorias: MercadoriasModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  constructor(
    formBuilder: FormBuilder,
    private mercadoriasService: MercadoriasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao[0].url == 'mercadorias') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      nome: [],
      ncm: []
    });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.getPage(1);
  }

  duplicar(mercadoria) {
    mercadoria.duplicando = true;

    this.mercadoriasService.duplicar(mercadoria.id)
      .subscribe(
        json => {
          mercadoria.duplicando = false;
          this.func.alerta(this.func.traduzir('front.sucesso'), this.func.traduzir('back.operacaoRealizadaSucesso'), 'sucesso');
          this.getPage(this.paginaAtual);
        },
        error => {
          mercadoria.duplicando = false;
          this.func.showErro(error.json());
        }
      );
  }

  delete(mercadoria) {
    let mercadorias = this.mercadorias;
    let mercadoriasService = this.mercadoriasService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarMercadoria') + mercadoria.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(mercadorias);
        }

        let index = mercadorias.indexOf(mercadoria);
        mercadorias.splice(index, 1);

        mercadoriasService.apagar(mercadoria.id)
          .subscribe(res => {
            self.mercadorias = mercadorias;
          },
            err => {
              // Revert the view back to its original state
              mercadorias.splice(index, 0, mercadoria);
              self.mercadorias = mercadorias;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.filtroPesquisa.ncm != '') {
      filtros['ncm'] = '**:' + this.filtroPesquisa.ncm;
    }

    if (this.filtroPesquisa.nome != '') {
      filtros['nome_padrao'] = '**:' + this.filtroPesquisa.nome;
    }

    this.mercadoriasService.getPaginacao(pagina, this.itensPorPagina, null, filtros)
      .subscribe(data => {
        this.mercadorias = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "nome": "", "ncm": "" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias/mercadorias.component.ts